import React from "react";

export class TicketComponent extends React.Component {
  render() {
    const priceStyle = {
      textAlign: 'right',
    };

    console.log(this.props.order.toJS())
    const customerName = this.props.order.get("customerName");
    const orderLines = this.props.order.get("orderLines");
    const customerTeam = this.props.order.getIn(["team", "name"]) ? <span style={{fontSize: "small"}}>{`Equipo: ${this.props.order.getIn(["team", "name"])}`}</span> : ''

    const calculateDescription = getTeamById => variationDetails => {
      const description = variationDetails
        .map(f => {
          const value = f.name === 'Equipo' ? getTeamById(f.value) : f.value;
          const desc = `${f.name}: ${value}`;
          return desc;
        })
        // .reduce((a, b) => a + " - " + b);
        .reduce((a, b) => (<div>{a} <br /> {b}</div>));
      return description;
    };

    const calcDesc = calculateDescription(this.props.getTeamById)


    let lines = orderLines.map((line, index)=> {
        return <tr key={index}>
          <td className="cantidad">{line.get("quantity")}</td>
          <td className="producto">
            <div style={{fontWeight: 'bold'}}>{line.get("variation").get("product").get("name")} {line.get("variation").get("name")}</div>
            {calcDesc(line.toJS().variationDetails)}
          </td>
          <td className="precio" style={priceStyle}>{line.get("unitPrice")}€</td>
        </tr>
      }
    )

    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();

    return (
      <div className="ticket">
        <p className="center">
          Resguardo de compra 
          <br /><span style={{fontSize: "small"}}>{`${date} - ${time}`}</span>
          <br /><span style={{fontSize: "small"}}>{`Cliente: ${customerName}`}</span>
          <br />{customerTeam}
        </p>
        <table style={{margin: '0 auto'}}>
          <thead  style={{fontSize: 'medium'}}>
          <tr>
            <th className="cantidad">UD</th>
            <th className="producto">PRODUCTO</th>
            <th className="precio">IM</th>
          </tr>
          </thead>
          <tbody style={{fontSize: 'small'}}>
          {lines}
          <tr>
            <td className="cantidad" />
            <td className="summary">TOTAL</td>
            <td className="summary-price" style={priceStyle}> {orderLines
              .map(line => line.get("unitPrice") * line.get("quantity"))
              .reduce((a, b) => a + b, 0)}€</td>
          </tr>
          </tbody>
        </table>
        <p className="center"  style={{fontSize: "small"}}>
          www.arousafutbol7.com
          <br />
          <br />
          _____________________
        </p>
      </div>
    )

  }
}





// WEBPACK FOOTER //
// ./src/components/presentational/Ticket.js